// @ts-nocheck
export function b64toBlob(b64Data, contentType, sliceSize) {
    const usedContentType = contentType || '';
    const usedSliceSize = sliceSize || 512;

    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += usedSliceSize) {
        const slice = byteCharacters.slice(offset, offset + usedSliceSize);

        const byteNumbers = [slice.length];
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        byteArrays.push(new Uint8Array(byteNumbers));
    }

    return new Blob(byteArrays, { type: usedContentType });
}

//save b64 - content to a file
export function downloadFile(fileContent, type, name) {
    if (fileContent !== null) {
        const file = b64toBlob(fileContent, type);
        downloadBlob(file, name);
    }
}

//save blob to a file
export function downloadBlob(blob, name) {
    //for IE 10+
    if (navigator.msSaveBlob) {
        return navigator.msSaveBlob(blob, name);
    }

    const tempAnchor = document.createElement('a');
    const tempURL = window.URL.createObjectURL(blob);
    tempAnchor.href = tempURL;
    tempAnchor.download = name;
    document.body.appendChild(tempAnchor);
    tempAnchor.click();
    setTimeout(() => {
        document.body.removeChild(tempAnchor);
        window.URL.revokeObjectURL(tempURL);
    }, 100);
}

const toCSVCell = value => `${String(value ?? '').replace(/;/g, ' ')};`;

// Builds the CSV (semicolon separated, one line per row) from the row data instead of scraping the DOM,
// since the UIKIT 3 Table does not render <tr>/<th>/<td> elements.
// columns: [{ key, label }] in the order they should be exported, getCellText: (columnKey, row) => string
export function tableToCSV(columns, rows, getCellText) {
    const head = columns.map(column => toCSVCell(column.label)).join('');
    const body = rows.map(row => `\n${columns.map(column => toCSVCell(getCellText(column.key, row))).join('')}`);

    return [head, ...body].join('');
}
